/* eslint-disable @sailor/i18n-no-measurement-units */
import React, { FC, useEffect, useState } from 'react'
import { RepastPeriodItem, DeliveryAddressRule } from '@/pages/rule/utils/types'
import {  useTranslation } from '@sailor/i18n-web'
import { Button, Input, Radio, FormPro, Panel } from '@roo/roo'
import Modal from '@roo/roo/Modal'
import { IDeliveryAddressItem } from '../../utils/types'
import MarkMap from '@/components/MarkMap'
import { loadMapScript } from '@/components/MarkMap/utils'
import styles from './index.module.less'

const RadioGroup = Radio.Group
interface AddressRuleProps {
  value: DeliveryAddressRule
  onChange: (val: DeliveryAddressRule) => void
}


const AddressRule: FC<AddressRuleProps> = (props) => {
  const { value } = props
  const { t } = useTranslation()
  const { checkDeliveryAddress } = value
  const deliveryAddressList = value.deliveryAddressList || []
  const limitVal = checkDeliveryAddress ?  'LIMIT' : 'NO_LIMIT'
  const [editRuleIndex, setEditRuleIndex] = useState<number | undefined>()
  const [userLoc, setUserLoc] = useState({ latitude: '', longitude: '' })
  useEffect(() => {
    getCurrentLocation(setUserLoc) // 获取用户默认地址
    loadMapScript() // 提前加载地图
  }, [])

  function handlePeriodItemChange (editIndex: number, data?: RepastPeriodItem) {
    setEditRuleIndex(undefined)
    let newList = [...deliveryAddressList]
    // @ts-ignore  允许置空,表示删除操作
    newList[editIndex] = data
    props.onChange({
      ...value,
      deliveryAddressList: newList.filter(item => item),
    })
  }

  return (
    <div >
      <RadioGroup value={limitVal} onChange={(val) => props.onChange({
        ...value,
        checkDeliveryAddress: val === 'LIMIT',
      })}>
        <Radio value={'NO_LIMIT'}>{t('e_pc_no_limit', '不限制')}</Radio>
        <Radio value="LIMIT">{t('e_pc_specific_address', '特定地址')}</Radio>
      </RadioGroup>
      {checkDeliveryAddress && (
        <div>
          {Number(editRuleIndex) >= 0 &&  (
            <PeridRuleItemModal
              userLoc={userLoc}
              value={deliveryAddressList[editRuleIndex as number]}
              onClose={() => setEditRuleIndex(undefined)}
              onConfirm={(newItem) => {
                handlePeriodItemChange(editRuleIndex as number, newItem)
              }}   />
          )}
          <AddressRender data={deliveryAddressList} onEdit={(index:number) => setEditRuleIndex(index)} onDelete={(index) => handlePeriodItemChange(index, undefined)}/>
          <Button style={{ marginTop: '12px' }} icon="plus"  type="hollow" size="mini" onClick={() => setEditRuleIndex(deliveryAddressList.length)} >{t('e_pc_add', '添加')}</Button>
        </div>
      )}
    </div>
  )
}

/** 新增地址弹窗 */
function PeridRuleItemModal (props: {
  value?: IDeliveryAddressItem,
  onConfirm: (val: IDeliveryAddressItem) => void
  onClose: () => void
  userLoc?: { latitude: string, longitude: string }
}) {
  const { t } = useTranslation()
  const isNew = !props.value
  const [form] = FormPro.useForm()
  const radiusValue = FormPro.useWatch('radius', form)


  const onFormSubmit = (values: any) => {
    props.onConfirm({
      description: values.description,
      latitude: values.location.latitude,
      longitude: values.location.longitude,
      radius: values.radius,
      address: values.location.address,
    })
  }

  const onFormError = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  const  labelCol = { span: 3 }

  return (
    <Modal
      title={isNew ? t('e_pc_add_address', '添加地址') : t('e_pc_edit_address', '编辑地址')}
      visible
      style={{ width: 800 }}
      onCancel={props.onClose}
      onConfirm={form.submit}
      cancelText={t('e_pc_cancel_button', 'Cancel')}
      confirmText={t('e_pc_confirm_button', 'Confirm')}
    >
      <FormPro
        name="address_rule"
        // labelCol={{ span: 2 }}
        labelCol={labelCol}
        wrapperCol={{ span: 9 }}
        initialValues={{
          description: props.value?.description,
          location: {
            longitude: props.value?.longitude ||  props.userLoc?.longitude,
            latitude: props.value?.latitude  || props.userLoc?.latitude,
            address: props.value?.address || '',
          },
          radius: props.value?.radius || 100,
        }
        }
        onFinish={onFormSubmit}
        onFinishFailed={onFormError}
        form={form}
        colon={false}
      >
        <FormPro.Item label={t('e_pc_address', '地址')} name="location"
          rules={[{ validator (rule, value) {
            if (!value?.address || !value?.latitude || !value?.longitude) {
              return Promise.reject(new Error(t('e_pc_select_address', '请选择地址')))
            } else {
              return Promise.resolve()
            }
          } }]}
        >
          <MapFormItem circle={radiusValue} />
        </FormPro.Item>
        <FormPro.Item
          label={t('e_pc_address_desc', '地址说明')}
          name="description"
          required
          validateTrigger={['onBlur']}
          wrapperCol={{ span: 8 }}
          labelCol={labelCol}
          rules={[{ required: true, message: t('e_pc_enter_address_desc', '请输入地址说明') }]}
        >
          <Input type="text" placeholder={t('e_pc_enter_address_desc_placeholder', '请填写这个地址的说明')} />
        </FormPro.Item>
        <FormPro.Item name="radius" required label={t('e_pc_distance_limit', '距离限制')}
          labelCol={labelCol}
          wrapperCol={{ span: 2 }}
          rules={[{ validator (rule, value) {
            const ruleReg =  /^(?:[5-9]\d|[1-9]\d{2,})$/
            if (!value || !ruleReg.test(value)) {
              return Promise.reject(new Error(t('e_pc_enter_distance', '请输入大于等于50的整数')))
            } else {
              return Promise.resolve()
            }
          } }]}
        >
          <Input suffix="m" placeholder={t('e_pc_enter_distance', '请输入大于等于50的整数')} />
        </FormPro.Item>
      </FormPro>
    </Modal>
  )
}

/** 地址地图表单项 */
function MapFormItem (props: {
  value?: {latitude: string, longitude: string, address?: string},
  onChange?: (val: {latitude: string, longitude: string, address:string}) => void,
  circle: number
}) {
  const { t } = useTranslation()
  return (
    <div>
      <div style={{ lineHeight: '40px', height: '40px' }}> {
        props.value?.address ||
       <span style={{ color: '#b8b8b8' }}>{t('e_pc_select_address', '请选择地址')}</span>
      }
      </div>
      <div style={{ width: '100%', height: '400px' }}>
        <MarkMap search drag
          icon="https://s3-ap-hongkong.mykeeta.net/sailorfempcpublic/SCMFiles/marker_red.png"
          value={{
            longitude: props.value?.longitude || '',
            latitude: props.value?.latitude || '',
          }}
          circle={Number(props.circle)}
          onChange={({ longitude, latitude, addressName }) => {
            props.onChange?.({ longitude: String(longitude), latitude: String(latitude), address: addressName || '' })
          }}
        />
      </div>
    </div>
  )
}

/** 地址列表展示 */
function AddressRender (props: {
  data:IDeliveryAddressItem[],
  onEdit: (index: number) => void
  onDelete: (index: number) => void
}) {
  const { t } = useTranslation()
  return (
    <div className={styles['address-render']} >
      {props.data?.map((item, index) => (
        <Panel title={item.description} style={{ marginTop: '12px' }}
          extra={
            <>
              {props.onEdit && (<Button type="brand-text" onClick={() => props.onEdit(index)} icon="edit" />)}
                  &ensp;
              {props.onDelete && (<Button type="brand-text" onClick={() => props.onDelete(index)} icon="trash-o" ></Button>)}
            </>
          }
        >
          {item.address}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <span>{t('e_pc_distance', '距离')}:&ensp;</span>
            <span>{item.radius}</span>
            <span>m</span>
          </div>
        </Panel>
      ))}
    </div>
  )
}


function getCurrentLocation (cb: any) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords
        cb({ latitude, longitude })
      },
      (error) => {
        console.error(`Error Code = ${error.code} - ${error.message}`)
      }
    )
  } else {
    console.error('Geolocation is not supported by this browser.')
  }
}

export default AddressRule